import React, { useEffect, useState, useRef, useCallback } from 'react'
import './forcedLabourDetails.css'

import redLogo from '../ui/kaleidoskop_logo_red.svg'



function ForcedLabourDetails({ person, visible, onSendData }) {

    const [daysOfLabour, setDaysOfLabour] = useState();


    const datailsRef = useRef(null);









    const setTimeOfLabour = (person) => {

        if (person.beschaeftigt_von_Jahr && person.beschaeftigt_bis_Jahr) {


            var startYear;
            var startMonth;
            var startDay;

            var endYear;
            var endMonth;
            var endDay;

            //setting the year

            if (Array.isArray(person.beschaeftigt_von_Jahr)) {

                startYear = Math.min(person.beschaeftigt_von_Jahr);
            }
            else {

                startYear = person.beschaeftigt_von_Jahr;
            }

            if (Array.isArray(person.beschaeftigt_bis_Jahr)) {
                endYear = Math.min(person.beschaeftigt_bis_Jahr);
            }
            else {

                endYear = person.beschaeftigt_bis_Jahr;
            }

            //seting the day
            if (person.beschaeftigt_von_Tag) {
                if (Array.isArray(person.beschaeftigt_von_Tag)) {

                    startDay = Math.min(person.beschaeftigt_von_Tag);
                }
                else {
                    startDay = person.beschaeftigt_von_Tag;
                }

            }
            else {

                startDay = 1;
            }


            if (person.beschaeftigt_bis_Tag) {
                if (Array.isArray(person.beschaeftigt_bis_Tag)) {

                    endDay = Math.min(person.beschaeftigt_bis_Tag);
                }
                else {

                    endDay = person.beschaeftigt_bis_Tag;
                }

            }
            else {
                endDay = 28;
            }

            //setting the month
            if (person.beschaeftigt_von_Monat) {
                if (Array.isArray(person.beschaeftigt_von_Monat)) {

                    startMonth = Math.min(person.beschaeftigt_von_Monat);
                }

                else {

                    startMonth = person.beschaeftigt_von_Monat;
                }
            }
            else {

                startMonth = 1;
            }


            if (person.beschaeftigt_bis_Monat) {
                if (Array.isArray(person.beschaeftigt_bis_Monat)) {

                    endMonth = Math.min(person.beschaeftigt_bis_Monat);
                }

                else {

                    endMonth = person.beschaeftigt_bis_Monat;
                }
            }
            else {
                endMonth = 12;
            }



            const startDate = new Date(startYear, startMonth - 1, startDay);
            const endDate = new Date(endYear, endMonth - 1, endDay);

            const timeDifference = Math.abs(endDate - startDate);

            const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

            return (daysDifference);





        }

        else {


            return ('???')
        }
    }





    const sendDataToParent = () => {
        onSendData(false);
    }

    // Handler for outside click
    const handleClickOutside = useCallback((event) => {

        // onSendData(false);
       
        // Check if the click is outside of the div
        if (datailsRef.current && !datailsRef.current.contains(event.target)) {
            //   alert("Clicked outside the div!");
            onSendData(false);
        }


    }, [onSendData]);

    const handleESC =useCallback((event)=>{
        if (event.key === 'Escape') {
            onSendData(false);
        }
    }, [onSendData])



    useEffect(
        () => {








            setDaysOfLabour(setTimeOfLabour(person));


            document.addEventListener("mousedown", handleClickOutside);
            document.addEventListener("keydown", handleESC);

            // Clean up the event listener on unmount
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
                document.removeEventListener("keydown", handleESC);
            };



        }, [person, visible, handleClickOutside, handleESC]
    )


    const handleOpenInNewTab = () => {
        // Open a new tab with a URL containing the item ID
        window.open(`/archive/details?_id=${person._id}`, '_blank');
    };





    return (




        <div>



            <div className='popup' ref={datailsRef}  >


                <div className='stickyControls'>

                    <div className='controls_container'>
                        <div className='controls'>


                            <div onClick={handleOpenInNewTab}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7 6C6.44772 6 6 6.44772 6 7C6 7.55228 6.44772 8 7 8H14.5858L6.29289 16.2929C5.90237 16.6834 5.90237 17.3166 6.29289 17.7071C6.68342 18.0976 7.31658 18.0976 7.70711 17.7071L16 9.41421V17C16 17.5523 16.4477 18 17 18C17.5523 18 18 17.5523 18 17V7C18 6.44772 17.5523 6 17 6H7Z" fill="black" />
                                </svg>
                            </div>

                            {/* <img src={newTab} alt="" className='newTab' /> */}

                            <div onClick={sendDataToParent}>
                                <svg width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z" fill="black" />
                                </svg>





                            </div>






                        </div>


                    </div>

                </div>










                <div className='info'>


                    <div className='individual'>

                        <div>
                            <p id='name'>{person.Vorname} {person.Nachname}</p>
                        </div>


                        <div>
                            <p id='announce'>war zwangsarbeitend für ca.</p>

                        </div>
                        <div id='num_days'>
                            <p id='num'>{daysOfLabour}</p>
                            <p id='days'>Tage</p>

                        </div>





                    </div>
                    <div>

                        <div id='details_block'>
                            <div>
                                <p id='detail_name'> {person.Vorname} {person.Nachname}</p>
                            </div>

                            {

                                person.info.map((element, index) =>

                                    <div id='details' key={person._id + '_' + index}>
                                        <p id='detail_titel'></p>
                                        <p id='detail_text'>{element}</p>


                                    </div>

                                )

                            }



                        </div>
                    </div>


                    <div id='logo'>
                        <img src={redLogo} alt="" />
                    </div>




                </div>

            </div>









        </div>
    )
}

export default ForcedLabourDetails